import { Dispatch, SetStateAction, useCallback } from 'react'
import prop from 'ramda/es/prop'

import { api } from 'app/api'
import usePopup from 'app/common/hooks/usePopup'
import type { ImageParamsType } from 'app/common/components/ImagePrepare/ImagePrepare'
import { POST_COMPLEX_PHOTO_ADD_REMOVE } from 'app/common/api/requests/food/menu/complex_photo_add_remove'


type Actions = {
  saveImage: (imageParams: ImageParamsType) => Promise<boolean>
  deleteImage: () => Promise<boolean>
}

type Options = {
  orgId: string
  complexId: string
  buildingId?: number // опционально, вариант корпуса
  dietFoodTypeId?: number // опционально, вариант вида диет. питания
  date: string
}

type OnPhoto = Dispatch<SetStateAction<string>>

export default function usePhoto(
  { orgId, complexId, date, buildingId, dietFoodTypeId }: Options,
  onPhoto: OnPhoto,
): Actions {
  const popup = usePopup()

  const handleSaveImage = useCallback(async (imageParams: ImageParamsType) => {
    const res = await api.request(POST_COMPLEX_PHOTO_ADD_REMOVE, {
      error: 'Не удалось изменить фотографию',
      params: {
        school_id: orgId,
        complex_id: complexId,
        building_id: buildingId,
        diet_food_type_id: dietFoodTypeId,
        date,
        photo: imageParams,
      },
    })

    if (res) {
      onPhoto(prop(complexId, res) || '')
      popup('Фотография успешно изменена')
      return true
    }
    return false
  }, [popup, orgId, complexId, buildingId, dietFoodTypeId, date, onPhoto])

  const handleDeleteImage = useCallback(async () => {
    const res = await api.request(POST_COMPLEX_PHOTO_ADD_REMOVE, {
      error: 'Не удалось изменить фотографию',
      params: {
        school_id: orgId,
        complex_id: complexId,
        building_id: buildingId,
        diet_food_type_id: dietFoodTypeId,
        date,
        photo: null,
      },
    })

    if (res) {
      onPhoto(prop(complexId, res) || '')
      popup('Фотография успешно удалена')
      return true
    }
    return false
  }, [popup, orgId, complexId, buildingId, dietFoodTypeId, date, onPhoto])

  return {
    saveImage: handleSaveImage,
    deleteImage: handleDeleteImage,
  }
}
